import uuid from 'uuid-random'

let deviceId = localStorage.getItem('device_id')

if (!deviceId) {
  deviceId = uuid()
  localStorage.setItem('device_id', deviceId)
}

export default deviceId
